import { useState } from 'react'
import { useAppSelector, useMount } from 'shared/hooks'

import dangerIcon from '../../../assets/image/icons/svg/icons/danger.svg'
import { appSelectors } from '../../../redux/reducers/app'
import css from './LinkedInNotLogged.module.scss'

export function LinkedInNotLogged() {
	const isNotLogged = useAppSelector(appSelectors.notLoggedLI)

	return isNotLogged && <NotLoggedInner />
}

function NotLoggedInner() {
	const linkedInfo = useAppSelector(
		state => appSelectors.appProfile(state)?.linkedInProfile
	)
	const profile = useAppSelector(appSelectors.linkedProfile)
	const connector = useAppSelector(appSelectors.connector)
	const [linkedInProfile, setLinkedInProfile] = useState<any | null>(null)

	let id = profile?.publicIdentifier || profile?.entityId

	if (linkedInProfile) {
		id = profile?.entityId || profile?.publicIdentifier
	}

	useMount(() => {
		connector.linkedIn.getCurrentProfile().then((res: any) => {
			setLinkedInProfile(res)
		})
	})

	return (
		<article className={css.root}>
			<img
				alt='danger icon'
				className={css.icon}
				height={14}
				src={dangerIcon}
				width={14}
			/>

			<span>
				You are not logged in to LinkedIn with{' '}
				<a
					className={css.link}
					href={`https://www.linkedin.com/in/${id}/`}
					rel='noopener noreferrer'
					target='_blank'
				>
					{`${linkedInfo?.givenName} ${linkedInfo?.familyName} account.`}
				</a>
			</span>
		</article>
	)
}
